import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { ILocationHistory } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetLocationDataHistories = (
  locationCode: string,
  date: string,
  enabled = true,
) => {
  const filters = [`location_code=${locationCode}`, `date=${date}`];

  return useQuery({
    queryKey: queryKeys.locationDataHistory.all(filters),
    queryFn: () => fetchLocationDataHistories(filters),
    enabled: enabled && !isEmpty(filters),
    staleTime: Infinity,
  });
};

const fetchLocationDataHistories = async (filters: string[] = []) => {
  const query = generateQuery([], filters);

  const url = `/locationDataHistory${query}`;

  const response = await requestCCApi({ url });

  return (response as ILocationHistory).versions;
};
